module.exports = __webpack_public_path__ + "img/Feature.919b3e1b.png";